import clsx from "clsx";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useAppDispatch } from "../../../../lib/redux/hooks";
import { colors } from "../../../../ui/colors";
import { PlusIcon } from "../../../../ui/icons/plus";
import Button from "../../../../ui/molecules/button";
import { Spinner } from "../../../../ui/molecules/spinner";
import { ContactStateEnum } from "../../dto";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    contactId?: string;
    listIndex: number;
    isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
}

export function KoModal({ isOpen, onClose, contactId, listIndex, isLoading, handleConfirm }: Props) {
    useEffect(() => {
        const handleEscKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        };
    }, []);

    const dispatch = useAppDispatch();

    return createPortal(
        <div
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
            }}
            className={clsx(
                "transition-all fixed bg-opacity-30 z-[50] bg-neutral-950 backdrop-blur-sm top-0 left-0 right-0 bottom-0 h-full w-full flex items-center justify-center",
                {
                    block: isOpen,
                    hidden: !isOpen,
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                className="transition-all relative bg-white rounded-[12px] opacity-100 shadow-sm min-w-[600px]"
            >
                <div
                    onClick={() => onClose()}
                    className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                >
                    <PlusIcon color={colors.brandPrimary[600]} size={16} />
                </div>
                <div className="p-6 text-heading-xs font-semibold text-center">
                    Registro opposizioni
                </div>
                <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
                    <p className="text-text-md font-medium text-neutral-600 text-center max-w-lg">
                        Cliccando su "<span className="font-bold text-neutral-800">Conferma</span>"  il contatto verrà registrato come opposizione e non sarà più possibile contattarlo.
                        <br />
                        <br />
                    </p>
                    <div className="flex w-3/4 items-center gap-4">
                        <div className="flex-1">
                            <Button size={"sm"} iconPosition={"left"} variant={"outline"} color={"gray"} label="Annulla" onClick={() => onClose()} fullWidth />
                        </div>
                        {
                            isLoading ?
                                <div className="flex-1 flex items-center justify-center">
                                    <Spinner color="primary" size={32} />
                                </div> :
                                <div className="flex-1">
                                    <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"red"} label="Conferma" fullWidth
                                        onClick={() => handleConfirm(ContactStateEnum.OPPOSITIONS, null)}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>,
        document.body
    )
}